import { Button } from '@/components/ui/button';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const HeroSection = () => {
  const { t } = useLanguage();

  const scrollToMenu = () => {
    const element = document.querySelector('#menu');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src="https://images.pexels.com/photos/29148133/pexels-photo-29148133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Comida india tradicional" className="w-full h-full object-cover" />
        <div className="hero-overlay absolute inset-0"></div>
      </div>
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto pt-20">
        <span className="overline text-[#E28743] mb-4 block animate-fade-in-up opacity-0" style={{ animationDelay: '100ms', animationFillMode: 'forwards' }}>
          {t('hero_overline')}
        </span>
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#FDFBF7] mb-6 leading-tight animate-fade-in-up opacity-0" style={{ animationDelay: '200ms', animationFillMode: 'forwards' }} data-testid="hero-title">
          {t('hero_title_1')}<br /><span className="text-[#E28743]">{t('hero_title_2')}</span>
        </h1>
        <p className="font-sans text-base md:text-lg text-[#FDFBF7]/90 mb-8 max-w-2xl mx-auto animate-fade-in-up opacity-0" style={{ animationDelay: '300ms', animationFillMode: 'forwards' }}>
          {t('hero_desc')}
        </p>
        <div className="flex justify-center animate-fade-in-up opacity-0" style={{ animationDelay: '400ms', animationFillMode: 'forwards' }}>
          <Button onClick={scrollToMenu} className="btn-primary px-10 py-6 text-lg shadow-2xl hover:shadow-[#C44536]/40 transition-shadow" data-testid="view-menu-btn">
            {t('hero_btn_menu')}
          </Button>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <button onClick={scrollToMenu} className="text-[#FDFBF7]/70 hover:text-[#FDFBF7] transition-colors" aria-label="Scroll down">
          <ChevronDown className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
